// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"__snackbarContainer___2lbC5"};